import { render, staticRenderFns } from "./SalesPerCustomer.vue?vue&type=template&id=e0dc4b08"
import script from "./SalesPerCustomer.vue?vue&type=script&lang=js"
export * from "./SalesPerCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports